import StatusTag from '@/components/_common/StatusTag';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  value?: number;
}

export default function PecaAiShippingAmountFlag(props: Props) {
  if (typeof props.value === 'number' && props.value > 0) {
    return <>{formatterPrice(props.value)}</>;
  }
  return <StatusTag color="green" label="Gratis" />;
}
